import { createSelector } from 'reselect';
import { getProp } from '../../utilities';

const enterStationsDomainSelector = state => state.enterStations;

export const enterStationsIsFetchingSelector = createSelector(
  enterStationsDomainSelector,
  substate => getProp(substate, ['isFetching'], false),
);

export const enterStationsListSelector = createSelector(
  enterStationsDomainSelector,
  substate => {
    const stations = getProp(substate, ['stations'], []);

    const statesMap = {};
    stations.forEach(station => {
      if (!(station.state in statesMap)) {
        statesMap[station.state] = [];
      }
      statesMap[station.state].push(station);
    });

    return Object.keys(statesMap).map(state => {
      return {
        value: statesMap[state].map(station => ({
          value: station.from_station,
          label: station.name,
        })),
        label: state,
      };
    });
  },
);

const toStationsDomainSelector = state => state.stationTo;

export const toStationsIsFetchingSelector = createSelector(
  toStationsDomainSelector,
  substate => getProp(substate, ['isFetching'], false),
);

export const getSelectedStation = createSelector(
  toStationsDomainSelector,
  substate => getProp(substate, ['selected'], null),
);

export const toStationsListSelector = createSelector(
  toStationsDomainSelector,
  getSelectedStation,
  (substate, selected) => {
    const stations = getProp(substate, ['byFromStationId'], {});
    if (selected) {
      const statesMap = {};
      stations[selected].forEach(station => {
        if (!(station.state in statesMap)) {
          statesMap[station.state] = [];
        }
        statesMap[station.state].push(station);
      });

      return Object.keys(statesMap).map(state => {
        return {
          value: statesMap[state].map(station => ({
            value: station.to_station,
            label: station.name,
          })),
          label: state,
        };
      });
    }
    return [];
  },
);


// WEBPACK FOOTER //
// ./src/containers/ConnectionForm/selectors.js